<template>
  <div class="el-section">
    <dash-transfers></dash-transfers>
  </div>
</template>

<script>
import '@pagarme/transfers/web-comp'

export default {
  name: 'transfers'
}
</script>
